export const headers = [
  {
    name: "Clave Profesor",
    col: 0,
    id: "clave_profesor",
    width: "10%",
    align: "center",
    fn: null,
  },
  {
    name: "Nombre Profesor",
    col: 1,
    id: "nombre_profesor",
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Campus",
    col: 2,
    id: "campus",
    width: "15%",
    align: "center",
    fn: null,
  },
  {
    name: "Escuela",
    col: 3,
    id: "escuela",
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Fecha",
    col: 4,
    id: "fecha",
    width: "10%",
    align: "center",
    fn: null,
  },
  {
    name: "Estatus Bloqueo",
    col: 5,
    id: "estatus",
    width: "15%",
    align: "center",
    fn: null,
  },
];

export const headersTable = [
  { name: "Clave Profesor", col: 0 },
  { name: "Nombre", col: 1 },
  { name: "Campus", col: 2 },
  { name: "Escuela", col: 3 },
  { name: "Fecha", col: 4 },
  { name: "Estatus", col: 4 },
  { name: "Acciones", col: 6 },
];

export const headersBloqueoProcesar = [
  { name: "Clave Profesor", col: 0 },
  { name: "Nombre", col: 1 },
  { name: "Campus", col: 2 },
  { name: "Escuela", col: 3 },
  { name: "Motivo", col: 4 },
  { name: "Fecha", col: 5 },
  { name: "Estatus", col: 6 },
  { name: "Procesar", col: 7 },
];

export const headersDesbloqueoProcesar = [
  { name: "Clave Profesor", col: 0 },
  { name: "Nombre", col: 1 },
  { name: "Campus", col: 2 },
  { name: "Escuela", col: 3 },
  { name: "Motivo", col: 4 },
  { name: "Autorizado Por", col: 5 },
  { name: "Fecha", col: 6 },
  { name: "Estatus", col: 7 },
  { name: "Procesar", col: 8 },
];

export const headersBloqueoEstatus = [
  { name: "Clave Profesor", col: 0 },
  { name: "Nombre", col: 1 },
  { name: "Campus", col: 2 },
  { name: "Escuela", col: 3 },
  { name: "Estatus", col: 4 },
];

export const optionsEstatus = [
  { label: "Activo", value: "Activo" },
  { label: "Inactivo", value: "Inactivo" },
  { label: "Ambos", value: "Ambos" },
];
